import Platform from './container';

export default Platform;
